import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

export function getHighlightStyles(isHighlighted: boolean) {
  return {
    borderColor: isHighlighted ? 'tIndigo.base' : 'tGray.back',
    borderRadius: 'md',
    bg: isHighlighted ? 'tBlue.hover' : undefined,
    transition: 'border-color 1.5s ease, background 1.5s ease',
    borderWidth: isHighlighted ? '1px' : '0',
  };
}

export function useSettingsSectionHighlight(sectionKey: string): boolean {
  const [searchParams, setSearchParams] = useSearchParams();
  const shouldHighlight = searchParams.get('highlight') === sectionKey;

  const [isHighlighted, setIsHighlighted] = useState(shouldHighlight);

  useEffect(() => {
    if (!shouldHighlight) {
      setIsHighlighted(false);
      return;
    }

    setIsHighlighted(true);
    const timer = setTimeout(() => {
      setIsHighlighted(false);
      const next = new URLSearchParams(searchParams);
      next.delete('highlight');
      setSearchParams(next, { replace: true });
    }, 2500);
    return () => clearTimeout(timer);
  }, [shouldHighlight, sectionKey, searchParams, setSearchParams]);

  return isHighlighted;
}
